import { useMutation } from '@apollo/client/react'
import { LOGIN } from './queries/login'

export function useLogin() {
  return useMutation(LOGIN)
}
